import React from "react";
import { useNavigate } from "react-router";
import { ActivationsContext } from "./Context";
import { defaultData } from "../../services/data";
import { pick, isEqual } from "lodash";
import axios from "axios";

import LoaderSpinner from "../../components/LoaderSpinner/LoaderSpinner";

// @ts-ignore
import PatientEnrolmentForm from "../../components/enrolment/PatientEnrolmentForm";

const comparisonFields = [
  "dob",
  "first_name",
  "follow_up_email_address",
  "follow_up_post_address",
  "follow_up_sms_number",
  "hba1c",
  "indigenous",
  "ndss",
  "postcode",
  "surname",
  "title",
];

type PropsType = {
  csrfToken: string;
};

export default function Enrol({ csrfToken }: PropsType) {
  const [sendingData, setSendingData] = React.useState<boolean | null>(null);
  const [appData, setAppData] = React.useContext(ActivationsContext);
  const navigate = useNavigate();

  const initialValues = {
    ...defaultData,
    ...appData.patientEnrolmentFormData,
    ...appData.params,
  };

  const handleSaveEnrolmentForm = async (values: PatientEnrolmentForm) => {
    const query_params = JSON.stringify(
      Object.fromEntries(new URLSearchParams(location.search))
    );

    const enrolment = {
      ...values,
      recall_months: values.last_eye_test,
      research_participant: false,
      query_params,
    };

    const config = { headers: { "X-CSRF-TOKEN": csrfToken } };

    const fieldsChanged = (() => {
      const pickedValues = pick(values, comparisonFields);

      const pickedInitialValues = pick(initialValues, comparisonFields);

      return isEqual(pickedValues, pickedInitialValues) === false;
    })();

    setSendingData(true);

    try {
      await axios.post(
        "/patient_enrolments",
        {
          enrolment,
          skip_recaptcha: true,
          campaign_member_id: appData.params.campaignmember_id,
        },
        config
      );
    } catch (error: any) {
      console.log("Error saving details");
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      throw error;
    }

    setSendingData(false);

    navigate(
      `/activations/eye_check_message?&lastEyeTestCode=${
        enrolment.last_eye_test
      }&postcode=${
        enrolment.postcode
      }&fieldsChanged=${fieldsChanged.toString()}`
    );
  };

  if (sendingData === true) {
    return (
      <div className="flex items-center">
        <LoaderSpinner />
        <div className="my-8 p-4 bg-gray-100 text-center">Sending data...</div>
      </div>
    );
  }

  return (
    <>
      <PatientEnrolmentForm
        saveEnrolmentForm={handleSaveEnrolmentForm}
        values={initialValues}
      />
    </>
  );
}
